import { render, staticRenderFns } from "./syncdata-loading.vue?vue&type=template&id=ac125d32&"
import script from "./syncdata-loading.js?vue&type=script&lang=js&"
export * from "./syncdata-loading.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports